export const quarterTime = (input: string | number): string => {
  const inputParsedToNumber = Number(input);
  const num =
    inputParsedToNumber % 0.25 !== 0
      ? Math.round(inputParsedToNumber * 4) / 4
      : inputParsedToNumber;

  const hour = Math.floor(num);
  const min = Math.floor((num % 1) * 60);

  const hFormat = hour > 0 ? `${hour}h` : "";
  const mFormat = min > 0 ? `${min}min` : "";

  return `${hFormat} ${mFormat}`.trim();
};
